import './App.css';
import Navbar from './General_Component/Navbar.js';
import LeftSubHeader from './components/LeftSubHeader';
import RightSubHeader from './components/RightSubHeader';
import CardSection from './components/CardSection';
import MobileUIImage from './components/MobileUIImage';
import { useEffect, useRef } from 'react';
import observer from './utils/observer';
import MoreInfo from './components/MoreInfo';
// import PersonalizedMealPlan from './components/PersonalizedMealPlan';
import PaymentPlans from './components/PaymentPlans';
import Shredder from './components/Shredder';
import Articles from './components/Articles';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import TrainingCommunity from './components/TrainingCommunity';

function App() {
  const refValue = useRef(null);

  useEffect(() => {
    observer(refValue, 'lazy-load-image');
  }, [refValue]);
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  return (
    <div className="App">
      <Navbar />
      <div className="sub-header-container lazy-load-image" ref={refValue}>
        <LeftSubHeader />
        <RightSubHeader />
      </div>
      <CardSection />
      <MobileUIImage />
      <MoreInfo />
      <TrainingCommunity />
      {/* <PersonalizedMealPlan /> */}
      <PaymentPlans />
      <Testimonials />
      <Shredder />
      <Articles />
      <Footer />
    </div>
  );
}

export default App;
